import API from "@/api";

const SET_LIST = "SET_LIST";
const SET_LOADER = "SET_LOADER";
const SET_TOTALS_PAGINATION = "SET_TOTALS_PAGINATION";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const SET_SORT = "SET_SORT";

export default {
  namespaced: true,

  state: {
    list: "",
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: "",
    loader: false
  },

  actions: {
    async listAll({ state, commit }) {
      commit("SET_LOADER", true);

      try {
        let results = await API.Subscriptions.index(
          state.pagination.current,
          state.sort
        );
        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
      } catch (e) {
        throw e;
      }

      commit("SET_LOADER", false);
    },

    setCurrentPage({ commit, dispatch }, pagination) {
      commit("SET_CURRENT_PAGE", pagination.pageNumber);
      dispatch("listAll");
    },

    setSort({ commit, dispatch }, payload) {
      commit("SET_SORT", payload);
      dispatch("listAll");
    }
  },

  mutations: {
    [SET_LIST](state, payload) {
      state.list = payload;
    },
    [SET_LOADER](state, payload) {
      state.loader = payload;
    },
    [SET_TOTALS_PAGINATION](state, payload) {
      state.pagination.totalPages = payload.page_count;
      state.pagination.totalResults = payload.record_count;
    },
    [SET_CURRENT_PAGE](state, payload) {
      state.pagination.current = payload;
    },
    [SET_SORT](state, payload) {
      state.sort = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/subscriptions.js